import React from 'react'
import { Router, Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import pt from 'prop-types'
import history from '../history'

import PageLayout from '../layouts/PageLayout/PageLayout'

class App extends React.Component {
  render() {
    return (
      <Provider store={this.props.store}>
        <div id="react-root">
          <Router history={history}>
            <Route path="/" component={PageLayout} />
          </Router>
        </div>
      </Provider>
    )
  }
}

App.propTypes = {
  store: pt.object
}

export default App
